import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone'
import { Loading } from '../Loading/Loading';
import './UploadZone.css'
import { Alert } from 'react-bootstrap';

export default function UploadZone({
    onDrop,
    fileUrl,
    isLoading,
    isDisabled = false,
    showMessageUploadLink = true,
    fileName,
    fileAccept = "pdf",
    container = "container"
}) {
    const [errorMessage, setErrorMessage] = useState('');
    const maxSize = 20971520; // 20Mb ~ 20971520.01 Bytes

    const fileAcceptType = {
        pdf: {
            mime: { 'application/pdf': ['.pdf'] },
            extension: ".pdf"
        },
        msg: {
            mime: { 'application/vnd.ms-outlook': ['.msg'] },
            extension: ".msg"
        },
        xlsx: {
            mime: {
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                'application/vnd.ms-excel': ['.xls']
            },
            extension: ".xls, .xlsx"
        }
    }


    const { getRootProps, getInputProps, fileRejections /*, open*/ } = useDropzone({
        maxSize: maxSize,
        minSize: 1,
        maxFiles: 1,
        disabled: isDisabled,
        noClick: isLoading,
        noKeyboard: isLoading,
        accept: fileAcceptType[fileAccept].mime,
        onDrop: onDrop,
        onDropRejected: (rejectedFiles) => {
            if (rejectedFiles && rejectedFiles.length > 0) {
                const rejectedFile = rejectedFiles[0];

                if (rejectedFile.file.size > maxSize) {
                    setErrorMessage(`ERROR: [${rejectedFile.file.name} - ${bytesToSize(rejectedFile.file.size)}]: El archivo es más grande que el tamaño máximo permitido de ${bytesToSize(maxSize)}.`);
                } else if(rejectedFile.file.size === 0) {
                    setErrorMessage(`ERROR: [${rejectedFile.file.name} - ${bytesToSize(rejectedFile.file.size)}]: El archivo está vacío.`);
                } else {
                    setErrorMessage(`ERROR: [${rejectedFile.file.name} - ${bytesToSize(rejectedFile.file.size)}]: El tipo de archivo no es permitido.`);
                }
            }
        }
    });

    const getFileName = (url) => {
        const parts = url.split("/");
        return parts[parts.length - 1];
    }

    const bytesToSize = (bytes) => {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Bytes';
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    return <>
        <section className={`${container} upload-zone`}>
            {fileUrl || fileName ?
                <>
                    <Alert key='warning' variant='info'>
                        <b>INFORMACIÓN: </b>Actualmente tiene cargado el archivo "<em>{fileName ? fileName : getFileName(fileUrl)}</em>"
                        {showMessageUploadLink && (
                            <>
                                . Pulse <a href={`${fileUrl}`} target="_blank" className="fs-5 fw-bold" rel="noreferrer">aquí</a> para visualizarlo.
                            </>
                        )}
                    </Alert>
                </> :
                <Alert key='warning' variant='warning'>
                    <div className='text-danger'>
                        <b>ADVERTENCIA: </b>Aún no ha cargado ningún archivo.
                    </div>
                </Alert>
                
            }
            {/* <div className="alert alert-secondary" role="alert">
                {fileUrl || fileName ?
                    <>
                        <i className="fi fi-rr-info me-2 align-middle"></i>
                        Actualmente tiene cargado el archivo {fileName ? fileName : getFileName(fileUrl)}
                        {showMessageUploadLink && (
                            <>
                                . Pulse <a href={`${fileUrl}`} target="_blank" className="fs-5 fw-bold" rel="noreferrer">aquí</a> para visualizarlo.
                            </>
                        )}
                    </> :
                    <div className='text-danger'>
                        <i className="fi fi-rr-triangle-warning me-3 align-middle"></i>
                        Aún no ha cargado ningún archivo.
                    </div>
                }
            </div> */}
            <div {...getRootProps({ className: 'dropzone' })} className='upload-zone__dropzone'>

                <input {...getInputProps()} />
                <img src="/static/media/UploadIcon.469126df.svg" className="uploadIcon" alt="Upload Icon" />
                <p>Arrastra y suelta un archivos aquí o haz clic para seleccionar archivos</p>
                <p className="">(Tamaño máximo: {bytesToSize(maxSize)}, Formato aceptado : {fileAcceptType[fileAccept].extension})</p>

                {fileRejections.length > 0 &&
                    <div className="upload-zone__error-container">
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    </div>
                }

                {isLoading &&
                    <div className='upload-zone__loading'>
                        <Loading></Loading>
                    </div>
                }

            </div>
        </section>

    </>
}